function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#ef4f82}\r\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_112495",
  transform: "translate(-894.753 -320)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_112494",
  transform: "translate(-19.247 -30.132)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_register_3194805",
  transform: "translate(914 362.059)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_112493"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_227135",
  d: "M84.572 53H53.519a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h31.053a3.919 3.919 0 0 0 0-7.839z",
  className: "cls-1",
  transform: "translate(7.079 23.124)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227136",
  d: "M84.572 66.1H53.519a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h31.053a3.919 3.919 0 0 0 0-7.839z",
  className: "cls-1",
  transform: "translate(7.079 29.771)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227137",
  d: "M84.572 79.2H53.519a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h31.053a3.919 3.919 0 0 0 0-7.839z",
  className: "cls-1",
  transform: "translate(7.079 36.418)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227138",
  d: "M45.437 53h-3.618a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h3.618a3.919 3.919 0 0 0 0-7.839z",
  className: "cls-1",
  transform: "translate(1.142 23.124)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227139",
  d: "M45.437 66.1h-3.618a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h3.618a3.919 3.919 0 1 0 0-7.839z",
  className: "cls-1",
  transform: "translate(1.142 29.771)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227140",
  d: "M45.437 79.2h-3.618a3.892 3.892 0 0 0-3.919 3.919 3.991 3.991 0 0 0 3.919 3.919h3.618a3.919 3.919 0 0 0 0-7.839z",
  className: "cls-1",
  transform: "translate(1.142 36.418)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_227141",
  d: "M125.357 56.767L98.375 29.784a4.118 4.118 0 0 0-2.864-1.206h-18.24a33 33 0 1 0-45.222 37.233v75.973a3.892 3.892 0 0 0 3.919 3.919h86.375a3.892 3.892 0 0 0 3.919-3.919V59.631a2.947 2.947 0 0 0-.905-2.864zM96.264 38.829l20.049 20.049H96.264zm-76.275-3.317a25.023 25.023 0 1 1 25.023 25.023 24.961 24.961 0 0 1-25.023-25.023zm20.2 102.2v-69.64a26.545 26.545 0 0 0 4.974.452 32.93 32.93 0 0 0 32.862-31.806h10.4V63.1a3.892 3.892 0 0 0 3.919 3.919h26.38v70.848H40.189z",
  className: "cls-1",
  transform: "translate(-12 -2.5)"
}))), /*#__PURE__*/React.createElement("text", {
  id: "x",
  fill: "#ef4f82",
  fontFamily: "Quicksand-Bold, Quicksand",
  fontSize: "60px",
  fontWeight: 700,
  transform: "translate(932.247 410.132)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "x"))));
function SvgNotRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.356,
    height: 155.132,
    viewBox: "0 0 114.356 155.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegistered);
export default __webpack_public_path__ + "static/media/not_registered.be2983cb597148ce658ad07e67a055b0.svg";
export { ForwardRef as ReactComponent };